<template>
    <div>
        <div v-if="loading" class="brand-container">
            <p class="mt-3">Loading...</p>
        </div>

        <div v-else-if="error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="getBrandProducts"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="hero">
                <div class="brand-container">
                    <div class="hero__content">
                        <div class="hero__logo">
                            <router-link to="/"><img :src="brand.logo" alt="" /></router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="brand-page brand-section">
                <div class="brand-container">
                    <section class="cabinet__breadcrumbs">
                        <router-link
                            to="/"
                            class="cabinet__breadcrumbs-link d-flex"
                            >{{ brand.name }}</router-link
                        >
                        <span class="cabinet__breadcrumbs-arrow d-flex"
                            >&rsaquo;</span
                        >
                        <a
                            href="javascript:void(0)"
                            class="cabinet__breadcrumbs-link"
                            >Каталог</a
                        >
                    </section>
                    <header
                        class="cabinet-header flex flex-align-center flex-justify-sb"
                    >
                        <h1 class="h1 cabinet-title">Каталог</h1>
                    </header>
                    <brand-products
                        :brand="brand.brand"
                        :is-subdomain-brand="true"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BrandProducts from '@/components/Public/Brand/Products'

import settings from '@/settings'

export default {
    name: 'SubdomainBrandProducts',
    components: {
        BrandProducts
    },
    data() {
        return {
            error: false,
            loading: true
        }
    },
    computed: {
        ...mapGetters('subdomainBrand', {
            brand: 'item'
        }),
    },
    async created() {
        await this.getBrandProducts()

        document.title = `Каталог ${this.brand.name}`
    },
    methods: {
        ...mapActions('subdomainBrand', {
            getBrand: 'getItem'
        }),
        async getBrandProducts() {
            try {
                this.loading = true
                this.error = false
                this.$Progress.start()

                await this.getBrand(settings.BRAND_ID)
            } catch (e) {
                this.error = true
            } finally {
                this.loading = false
                this.$Progress.finish()
            }
        }
    }
}
</script>

<style>
.filters-panel--border-bottom::after {
    display: none;
}
</style>
